import i18next from "../i18n";

export const experiences = {
  sectionTitle: i18next.t("experiences.sectionTitle"),
  icon: null,
  description: null,
  list: [
    {
      title: i18next.t("experiences.bxblue.title"),
      company: i18next.t("experiences.bxblue.company"),
      description: i18next.t("experiences.bxblue.description"),
      companyLink: i18next.t("experiences.bxblue.companyLink"),
      companyShortDetail: i18next.t("experiences.bxblue.companyShortDetail"),
      date: i18next.t("experiences.bxblue.date"),
    },
    {
      title: i18next.t("experiences.skillab.title"),
      company: i18next.t("experiences.skillab.company"),
      description: i18next.t("experiences.skillab.description"),
      companyLink: i18next.t("experiences.skillab.companyLink"),
      companyShortDetail: i18next.t("experiences.skillab.companyShortDetail"),
      date: i18next.t("experiences.skillab.date"),
    },
    {
      title: i18next.t("experiences.devops.title"),
      company: i18next.t("experiences.devops.company"),
      description: i18next.t("experiences.devops.description"),
      companyLink: i18next.t("experiences.devops.companyLink"),
      companyShortDetail: i18next.t("experiences.devops.companyShortDetail"),
      date: i18next.t("experiences.devops.date"),
    },
  ],
};

export default experiences;
